module.exports = __webpack_public_path__ + "static/media/ziv.ad1b3aa3.png";